<template>
  <div class="mt-2">
    <!-- eslint-disable-next-line max-len -->
    <p class="mt-1 text-sm text-gray-600">This name will appear on emails that are sent by the Heffron IQ portal and invoices for any purchases you make.</p>
    <div class="my-6 flex items-end space-x-2">
      <m-input
        class="flex-grow max-w-xl"
        id="account-name"
        label="Account Name"
        v-model="accountName"
      />
      <div class="relative">
        <m-button
          :disabled="loading"
          @click="handleUpdate"
        >
          Update
        </m-button>
        <div
          v-if="loading"
          class="absolute inset-0 flex items-center justify-center bg-blue-800 rounded"
        >
          <div class="h-4 w-4">
            <m-loader class="text-white"/>
          </div>
        </div>
      </div>
      <div>
        <m-button
          variant="secondary"
          :disabled="loading"
          @click="$emit('close')"
        >
          Cancel
        </m-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'account-edit',
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    activeAccount() {
      return this.$store.getters['account/getActiveAccount'];
    },
    accountName: {
      get() {
        return this.activeAccount.name;
      },
      set(val) {
        this.$store.dispatch('account/updateActiveAccountName', {
          name: val,
        });
      },
    },
  },
  methods: {
    handleUpdate() {
      this.loading = true;
      return this.$store.dispatch('account/updateActiveAccount', this.activeAccount)
        .then(() => {
          this.$emit('close');
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>
